import request from "../plugins/axios";

export function add(params) {
  return request({
    url: '/roomMessageBatchSend/store',
    method: 'POST',
    data: params
  })
}
